import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64decode',
})
export class Base64DecodePipe implements PipeTransform {
  transform(base64: string) {
    if (!base64) {
      return base64;
    }

    return atob(base64);
  }
}
